<app-top-nav-registration [llttfPage]="true"></app-top-nav-registration>
<div class="container">
    <div class="content" role="main">
      <!--comes here-->
      <div class="h-30"></div>
    <div class="facility-heading">Welcome To Living Life to the Full! <br> Create your account to get started.</div>
    <div class="designatedFacilityForm">
        <form>
        <app-registration-form [createuserobj]="createuserobj" [isSubmitted]="isSubmitted"></app-registration-form>
        <div class="form-buttons">
        <input type="submit" class="submit-form-button" (click)="onSubmit()" value="Submit"/>
        </div>
    </form>
    </div>
</div>
</div>
<app-footer></app-footer>
